export function timeRangeInHours(startMomentDate, endMomentDate) {
  // convert start and end date and time to string

  // remove seconds, miliseconds and Z
  const start = startMomentDate
    ?.format()
    .replace("T", " ")
    .replace(/:[0-9][0-9].[0-9][0-9][0-9]Z/g, "")
    .slice(0, 16);
  const end = endMomentDate
    ?.format()
    .replace("T", " ")
    .replace(/:[0-9][0-9].[0-9][0-9][0-9]Z/g, "")
    .slice(0, 16);

  let date1 = new Date(start);
  let date2 = new Date(end);

  // count days; always an integer number of days, when not integer, the next integer is used

  // time difference between dates
  let difference_in_time = date2.getTime() - date1.getTime();

  // no. of hours between dates
  let difference_in_hours = difference_in_time / (1000 * 3600);

  // integer number of days
  return difference_in_hours;
}
